import React, { Component } from 'react';
import { Button, Col, Container, Row, Card, CardBody } from 'reactstrap';
import Butt from '../c/Butt';
import API from '../API';
import { R } from '../routes';
import { T, TraksConsumer } from '../traks';
import I18N from '../I18N';
import { classes } from '../CUtil';
import { connect } from 'react-redux';
import { OpenSignupWithSuccessCallback } from '../c/SignupLogin';
import { MarketCards, get_market_data_by_id } from './Game';
import { default_currency, default_market, current_site_id } from '../Site';
import { Apify } from '../Apify';
import { ordered_and_available_market_ids } from '../markets';
import store from '../store';
import { getPremiumUpgradeTarget, setPendingCartGameId } from '../misc';
import { GameSetupSection } from './GameSetupSection';
import { TeamModuleSection } from './TeamModuleSection';
import { CapitalSection } from './CapitalSection';
import { GameMechanicsSection } from './GameMechanicsSection';
import { RiskValuesSection } from './RiskValuesSection';
import { DataAndAnalysisSection } from './DataAndAnalysisSection';
import { MarketsAndEquitySection } from './MarketsAndEquitySection';
import { GameActionSection } from './GameActionSection';
import { GameDiversificationSection } from './GameDiversificationSection';
import { Section } from './Section';

const DEFAULT_VOLUME_MULTIPLIER = 1.0;
const NO_VOLUME_MARKETS = ['CRYPTOCURRENCIES'];

class RadiosAndCustom extends Component {
	render() {
		var defaults = [];

		const value = this.props.parent.state[this.props.name];
		const is_custom_field = `${this.props.name}_is_custom`;
		const is_custom = !!this.props.parent.state[is_custom_field];

		const set_default = (e) => {
			const value = e.target.value;

			this.props.parent.setState({
				[this.props.name]: value,
				[is_custom_field]: false
			});
		};

		const click_custom = (e) => {
			if (this.custom_input) {
				this.custom_input.focus();
			}
			this.props.parent.setState({
				[this.props.name]: "",
				[is_custom_field]: true
			});
		};

		const set_custom_value = (value) => {
			this.props.parent.setState({
				[this.props.name]: value,
				[is_custom_field]: true
			});
		}

		const set_custom = (e) => {
			set_custom_value(e.target.value);
		};

		let a_default_is_checked = false;
		for (var i = 0; i < this.props.defaults.length; i++) {
			const item = this.props.defaults[i];
			const id = `${this.props.name}_${item.value}`;
			const checked = !is_custom && String(item.value) === String(value);
			if (checked) a_default_is_checked = true;

			defaults.push(
				<div key={id} className="ad_mobile_only">
				<div className="radio-item pr-lg-3">
					<input
						className="form-check-input"
						name={this.props.name}
						type="radio"
						id={id}
						value={item.value}
						checked={checked}
						onChange={set_default}
					/>
					<label className="form-check-label ad_3px_radius" htmlFor={id}>
						{item.text}
					</label>
				</div>
				</div>
			);
		}

		const use_custom = is_custom || !a_default_is_checked;

		const custom_id = `${this.props.name}_custom`;
		const custom_value = use_custom ? value : "";

		const correct_value = (e) => {
			const value = parseInt(e.target.value, 10);
			var corrected_value = Math.min(this.props.max, Math.max(this.props.min, value));
			if (isNaN(corrected_value)) corrected_value = this.props.min;
			if (corrected_value !== value) set_custom_value(corrected_value);
		}

		var custom_input_class = "pl-2 ad_input_newgame_custom ad_width_100px ad_height_50px";
		if (this.props.custom_error) {
			custom_input_class += " ad_input_error";
		}

		var custom;

		if (!this.props.no_custom) {
			custom = (
				<div className="radio-item">
					<input
						className="form-check-input"
						name={this.props.name}
						type="radio"
						id={custom_id}
						checked={use_custom}
						onChange={click_custom}
						onClick={click_custom}
					/>
					<label className="form-check-label-custom ad_3px_radius_no_right" htmlFor={custom_id}>
						{this.props.custom_text}&nbsp;
					</label>
					<span className="form-check-label-custom ad_3px_radius_no_left">
					<input
						placeholder={this.props.custom_placeholder}
						type="number"
						min={this.props.min}
						max={this.props.max}
						step={this.props.step}
						className={custom_input_class}
						value={custom_value}
						onChange={set_custom}
						onBlur={correct_value}
						ref={(input) => { this.custom_input = input; }}
					/>{this.props.custom_postfix}
					</span>
				</div>
			);
		}

		return (
			<div className={"ad_newgame_formgroup pt-2 " + (this.props.className || "")}>
				{defaults}
				{custom}
			</div>
		);
	}
}


const DatePick = (props) => {
	const minDate = props.minDate || new Date(props.anchor_date);
	const maxDate = props.maxDate;

	const isInviteEndCalendar = props.isInviteEndCalendar;
	
	let monthCount = props.monthCount;
	if (!monthCount && maxDate) {
	  const diffYears = maxDate.getFullYear() - minDate.getFullYear();
	  const diffMonths = maxDate.getMonth() - minDate.getMonth();
	  monthCount = diffYears * 12 + diffMonths + 1;
	}
	
	const tables = [];
	let d = new Date(minDate);
	let currentMonth = d.getMonth();
	let currentTable = { month: currentMonth, year: d.getFullYear(), rows: [] };
	let currentRow = [];
	
	while (tables.length < monthCount) {
	  const weekday = (d.getDay() + 6) % 7;
	  if (currentRow.length === 0) {
		for (let j = 0; j < weekday; j++) {
		  currentRow.push(null);
		}
	  }
	  
	  currentRow.push(new Date(d));
	  if (currentRow.length === 7) {
		currentTable.rows.push(currentRow);
		currentRow = [];
	  }
	  
	  d.setDate(d.getDate() + 1);
	  
	  if (d.getMonth() !== currentMonth) {
		if (currentRow.length > 0 && currentRow.length < 7) {
		  while (currentRow.length < 7) currentRow.push(null);
		  currentTable.rows.push(currentRow);
		  currentRow = [];
		}
		tables.push(currentTable);
		currentMonth = d.getMonth();
		currentTable = { month: currentMonth, year: d.getFullYear(), rows: [] };
	  }
	}
	
	const elements = tables.map(table => {
	  const trs = table.rows.map((row, rowIdx) => (
		<tr key={rowIdx}>
		  {row.map((date, idx) => {
			let cls = "ad_newgamedatepick_date";
			let onClick = null;
			let inner = <span />;
			if (date !== null) {
			  const outOfRange = (date < minDate) || (maxDate && date > maxDate);
			  if (outOfRange) {
				cls += " ad_newgamedatepick_date_disabled";
				inner = <span>{date.getDate()}</span>;
			  } else {
				if (
				  props.chosen_date &&
				  date.getFullYear() === props.chosen_date.getFullYear() &&
				  date.getMonth() === props.chosen_date.getMonth() &&
				  date.getDate() === props.chosen_date.getDate()
				) {
				  cls += " ad_newgamedatepick_date_chosen";
				  inner = <span>{date.getDate()}</span>;
				} else {
				  cls += " ad_newgamedatepick_date_not_chosen";
				  onClick = () => props.on_set_date(date);
				  inner = <span>{date.getDate()}</span>;
				}
			  }
			}
			return <td key={idx} className={cls} onClick={onClick}>{inner}</td>;
		  })}
		</tr>
	  ));
	  
	  const weekday_elements = [];
	  for (let i = 0; i < 7; i++) {
		weekday_elements.push(<th key={i}>{I18N.short_weekday(i)}</th>);
	  }
	  
	  return (
		<div key={`${table.year}-${table.month}`} className="ad_newgamedatepick">
		  <h1>{I18N.month(table.month)}</h1>
		  <table>
			<thead>
			  <tr>{weekday_elements}</tr>
			</thead>
			<tbody>{trs}</tbody>
		  </table>
		</div>
	  );
	});
	
	if (isInviteEndCalendar) {
	  return (
		<div>
		  <Row className="justify-content-start px-4">{elements}</Row>
		  <Row>
			<Col md="12" className="px-md-4">
			  <small><T>Invites will close at 8:00 AM on the chosen date</T></small>
			  <br/>
			</Col>
		  </Row>
		</div>
	  );
	}
	return (
	  <div>
		<Row className="justify-content-start px-4">{elements}</Row>
		<Row>
		  <Col md="12" className="px-md-4">
			<small><T>The game will start at 8:00 AM on the chosen date</T></small>
			<br/>
		  </Col>
		</Row>
	  </div>
	);
  };
3
const mk_market_select_key = (market_id) => "market_select_" + market_id;

class GameParams extends Component {
	constructor(props) {
		super(props);


		var anchor_date = new Date();
		anchor_date.setDate(anchor_date.getDate() + 1);

		const params_ex = props.params;
		let name = "";
		let brokerage_pct = 0;
		let max_amount_per_stock = "nolimit"

		let bankroll = 250000;
		let use_volume = false;
        let use_risk_values = false;
		let use_group_games = false;
        let use_portfolio_info = false
		let trade_amount_activated = false;
		let trade_amount = 50;
		let shorting_enabled = false;
		let shorting_amount = 20;
        let use_stock_info = false;
        let diversification_enabled = false;
        let diversification = {
            stocks: 20,
            bonds: 20,
            commodities: 20,
            crypto: 0,
        };
		if (params_ex) {
			const params = params_ex.Params;
			name = params.Name;
			brokerage_pct = params.BrokeragePct;
			bankroll = params_ex.BankrollInitialAmount;
			if (params.MaxAmountPerStock) {
				if (Math.round(params.MaxAmountPerStock) === Math.round(bankroll * 0.20)) {
					max_amount_per_stock = "20%";
				} else {
					max_amount_per_stock = params.MaxAmountPerStock + "";
				}
			}
			use_volume = params.VolumeMultiplier > 0;
            use_risk_values = params.RiskValues > 0;
			use_group_games = params.GroupGames > 0;
            use_portfolio_info = params.PortfolioInfo > 0;
            use_stock_info = params.StockInfo > 0;
			if (params.TradeAmount) {
				trade_amount = params.TradeAmount
				trade_amount_activated = params.TradeAmountActivated
			}
			shorting_enabled = params.ShortingEnabled > 0;
			shorting_amount = params.ShortingAmount || 20;
            diversification_enabled = params.DiversificationEnabled > 0;

            if (params.Diversification && params.Diversification.length > 0) {
                diversification = params.Diversification.reduce((acc, item) => {
                    acc[item.stock_type.toLowerCase()] = item.procents;
                    return acc;
                }, {});
            }
		}

		let inviteEndDate = null;
		if (
		props.mode === "edit" &&
		props.params &&
		props.params.Params &&
		props.params.Params.InviteEndTs
		) {
		inviteEndDate = new Date(props.params.Params.InviteEndTs);
		}

		let gameEndDate = null;
		if (
		props.mode === "edit" &&
		props.params &&
		props.params.Params &&
		props.params.Params.EndTime
		) {
		gameEndDate = new Date(props.params.Params.EndTime);
		}

		function isDefaultDate(date) {
			if (!date) return false; 
			return (
			  date.getFullYear() === 1 &&
			  date.getMonth() === 0 && 
			  date.getDate() === 1
			);
		  }

		  let inviteendcustomValue = "1";

		  if (props.mode !== "edit") {
			inviteendcustomValue = "0";
		  } else {
			let inviteEndDate = null;
			if (
			  props.mode === "edit" &&
			  props.params &&
			  props.params.Params &&
			  props.params.Params.InviteEndTs
			) {
			  inviteEndDate = new Date(props.params.Params.InviteEndTs);
			}
		  
			let gameEndDate = null;
			if (
			  props.mode === "edit" &&
			  props.params &&
			  props.params.Params &&
			  props.params.Params.EndTime
			) {
			  gameEndDate = new Date(props.params.Params.EndTime);
			}
		  
			if (inviteEndDate && gameEndDate) {
			  if (
				inviteEndDate.getTime() === gameEndDate.getTime() ||
				isDefaultDate(inviteEndDate)
			  ) {
				inviteendcustomValue = "0";
			  }
			}
		  }

		let market_state = {};
		if (props.mode === "new") {
			for (const market_id of ordered_and_available_market_ids) {
                if (market_id === default_market) {
                    market_state[mk_market_select_key(market_id)] = true;
                } else {
                    market_state[mk_market_select_key(market_id)] = false;
                }
            }

			const default_false_market_ids = ["CRYPTOCURRENCIES", "COMMODITIES", "AT_STOCK", "ETFS", "INDEXES", "FUNDS"];


			for (const market_id of default_false_market_ids) market_state[mk_market_select_key(market_id)] = false;
		} else if (props.mode === "edit") {
			for (const market_id of ordered_and_available_market_ids) market_state[mk_market_select_key(market_id)] = false;
			for (const market_id of props.params.Params.Markets) market_state[mk_market_select_key(market_id)] = true;
		}

		this.initial_market_state = {...market_state};
        
		this.state = {
			name,
			gametime: 30,
			gamestartcustom: 0,
			inviteendcustom: inviteendcustomValue,
            number_of_players: 10,
			gamestartcustom_anchor_date: anchor_date,
			gamestartcustom_chosen_date: anchor_date,
			inviteendcustom_anchor_date: anchor_date,
			inviteendcustom_chosen_date: inviteEndDate || anchor_date,
			bankroll,
			brokerage_pct,
			...market_state,
			currency: default_currency,
			max_amount_per_stock,
			use_volume,
            use_risk_values,
            allowed_beta_values: props.me && props.me.Subscription ? props.me.Subscription.includes('pro', 'enterprise') : false,
            user_is_premium: props.me && props.me.Subscription ? props.me.Subscription.includes('pro', 'enterprise') : false,
			trade_amount_activated,
			trade_amount,
            use_stock_info,
			use_group_games,
            use_portfolio_info,
			shorting_enabled,
			shorting_amount,
            diversification_enabled,
            diversification,
		};

		/* hack for debugging purposes */
		window.set_game_currency = (currency) => {
			this.setState({currency});
			return "OKIDOKI";
		};

		this.NoEdit = props.mode === "edit" ? props => null : props => props.children;
	}

	render() {
		const mk_market_card_props = (name, isPremium) => {
			const state_key = mk_market_select_key(name);
			return {
				selected: this.state[state_key],
				toggle: (e) => {
					e.preventDefault();
					
					this.setState((prev_state) => ({[state_key]: !prev_state[state_key]}));
				}
			};
		};

		const simple_change = (e) => {
			this.setState({
				[e.target.name]: e.target.value
			});
		};

        const handleDiversificationChange = (type, value) => {
            this.setState((prevState) => ({
                diversification: {
                    ...prevState.diversification,
                    [type]: value,
                }
            }));
        };

		const simple_checkbox_change = (e) => {
		const { name, checked } = e.target;

		if (name === "trade_amount_activated") {
			this.setState((prev) => ({
			[name]: checked,
			trade_amount: checked ? prev.trade_amount || 50 : prev.trade_amount,
			}));
			return;
		}

		this.setState({
			[name]: checked,
		});
		};

		var name_input_class = "ad_input ad_3px_radius ad_height_60px w-75 pl-3";
		if (this.state.invalid_input === "name") {
			name_input_class += " ad_input_error";
		}

		const state_invalid_input = this.state.invalid_input;
		const this_parent = this;

		const crypto_warning_text =
			(this.state.market_select_CRYPTOCURRENCIES && !this.initial_market_state.market_select_CRYPTOCURRENCIES)
			? <div className="ad_trade_notice"><T>*Crypto currencies are very volatile and alters the game dynamics</T></div>
			: null;

        const risk_value_warning_text = (this.state.use_risk_values)
            ? <div className='ad_trade_notice'><T>*With the addition of risk values, only assets with a risk score can be included in the game.</T></div> 
            : null;

		let no_volume_warning_text = null;
		if (this.state.use_volume) {
			let no_volume_markets = [];
			for (let market of NO_VOLUME_MARKETS) {
				if (this.state[mk_market_select_key(market)]) {
					no_volume_markets.push(market);
				}
			}
			if (no_volume_markets.length > 0) {
				let markets = no_volume_markets.map((id) => {
					let data = get_market_data_by_id(id);
					let content = id;
					if (data) {
						content = <span className="px-3"><img alt="" className="ad_market_card_smaller_img mr-1" src={data.img} />{data.title}</span>;
					}
					return <span key={id} className="ad_no_volume_market py-1 mr-2">{content}</span>;
				});
				no_volume_warning_text = (
					<div className="ad_trade_notice mr-2">
						<div>
							<T>*Volume gameplay is enabled, but the following markets have no volume data, and will be treated as having infinite volume:</T>
						</div>
						<div className="py-3">
							{markets}
						</div>
					</div>
				);
			}
		}

		var gameStartCalendar;
		if (this.state.gamestartcustom === "1") {
			const on_set_date = (date) => {
				this.setState({gamestartcustom_chosen_date: date});
			};
			gameStartCalendar = <DatePick
				anchor_date={this.state.gamestartcustom_anchor_date}
				chosen_date={this.state.gamestartcustom_chosen_date}
				on_set_date={on_set_date}
				monthCount={4}
			/>;
		}

		var inviteEndCalendar;
		if (this.state.inviteendcustom === "1") {
		const on_set_date = (date) => {
			this.setState({ inviteendcustom_chosen_date: date });
		};

		let maxDate;
		if (this.props.mode === "edit" &&
			this.props.params &&
			this.props.params.Params &&
			this.props.params.Params.EndTime) {
		// When editing, use the EndTime from props
		const end_time = new Date(this.props.params.Params.EndTime);
		const diff = end_time.getTime() - this.state.gamestartcustom_chosen_date.getTime();
		maxDate = new Date(this.state.gamestartcustom_chosen_date.getTime() + diff);
		} else {
		// For new games, calculate maxDate based on gametime (in days)
		maxDate = new Date(
			this.state.gamestartcustom_chosen_date.getTime() +
			this.state.gametime * 24 * 60 * 60 * 1000
		);
		}

		inviteEndCalendar = <DatePick
			anchor_date={this.state.inviteendcustom_anchor_date}
			chosen_date={this.state.inviteendcustom_chosen_date}
			on_set_date={on_set_date}
			minDate={this.state.gamestartcustom_chosen_date} 
			maxDate={maxDate} 
			isInviteEndCalendar = {true}
		/>;
		}

		const other_txt = <T>Other</T>;
		const nolimit_txt = <T>No limit</T>;
		var amount_txt = <T>Amount</T>;

		const validate_name = () => {
			if (this.state.name.trim().length === 0) {
				this.setState({invalid_input: "name"});
				// TODO focus? how?
				return false;
			}
			return true;
		};

		const validate_and_get_brokerage_pct = () => {
			const brokerage_pct = parseFloat(this.state.brokerage_pct);
			if (isNaN(brokerage_pct)) {
				this.setState({invalid_input: "brokerage_pct"});
				// TODO focus? how?
				return undefined;
			} else {
				return brokerage_pct;
			}
		};

		const get_selected_markets = () => {
			return ordered_and_available_market_ids.filter(x => this.state[mk_market_select_key(x)]);
		};

		const get_max_amount_per_stock = () => {
			var v = this.state.max_amount_per_stock;
			if (v === "nolimit") {
				return 0;
			} else if (v.slice(v.length-1) === "%") {
				const pct = parseInt(v.slice(0, v.length-1), 10);
				return Math.floor(this.state.bankroll * pct * 0.01);
			} else {
				return parseInt(this.state.max_amount_per_stock, 10);
			}
		};

		let header, submit_btn, not_enough_keys_warning_text;

        const premium_markets = ["DK_STOCK", "US_STOCK", "DE_STOCK", "SE_STOCK", "FI_STOCK", "AT_STOCK", "IS_STOCK", "CRYPTOCURRENCIES", "COMMODITIES", "ETFS", "INDEXES", "FUNDS"].filter(market_id => {
            return market_id !== default_market;
        });

        const isPremiumFeatureActived = this.state.use_group_games || this.state.use_portfolio_info || this.state.use_risk_values || this.state.inviteendcustom === "1" || this.state.use_stock_info || this.state.use_volume || this.state.shorting_enabled || this.state.diversification_enabled || get_selected_markets().some(market => premium_markets.includes(market)) || this.state.gametime > 30;
		if (this.props.mode === "new") {
			header = (
				<React.Fragment>
					<div className="game_bg_tarm">
						<Container>
						<Row>
							<Col className="mt-2" align="center">
							<img
								src="https://static.aktiedysten.dk/gfx/new-game-trophy-06-10-25.png"
								width="500"
								className="img-fluid"
								alt="Time for a new game!"
							/>
							</Col>
						</Row>

						<Row>
							<Col className="text-center">
							<h1><T>Create game</T></h1>
							</Col>
						</Row>

						<Row className="pt-3 justify-content-center rounded-bottom">
							<Col md="6" className="text-center">
							<T>Choose your game settings, invite your friends, and start your match.</T>
							</Col>
						</Row>
						</Container>
					</div>
					</React.Fragment>
				
			);

			let submit = (e) => {
				e.preventDefault();

				if (!validate_name()) return;

				var start_ts, end_ts, invite_end_ts;
				if (this.state.gamestartcustom === "1") {
					var start_date = new Date(this.state.gamestartcustom_chosen_date);
					start_date.setHours(8);
					start_date.setMinutes(0);
					start_date.setSeconds(0);
					start_date.setMilliseconds(0);
					start_ts = (start_date.getTime() / 1000) | 0;
				}

				if (this.state.inviteendcustom === "1") {
					invite_end_ts = Math.floor(new Date(this.state.inviteendcustom_chosen_date).getTime() / 1000);
				  }

				const duration_days = parseInt(this.state.gametime, 10);
				if (isNaN(duration_days)) {
					this.setState({invalid_input: "gametime"});
					// TODO focus? how?
					return;
				} else {
					end_ts = (start_ts ? start_ts : (Date.now()/1000)) + duration_days * 24 * 60 * 60;
				}

				const amount = parseInt(this.state.bankroll, 10);
				if (isNaN(amount)) {
					this.setState({invalid_input: "bankroll"});
					// TODO focus? how?
					return;
				}

				const brokerage_pct = validate_and_get_brokerage_pct();
				if (brokerage_pct === undefined) return;

				const markets = get_selected_markets();

				const pay_dividends = false; // TODO GUI

                const diversificationArr = Object.entries(this.state.diversification || {}).map(([stock_type, value]) => ({
                    stock_type,
                    procents: parseInt(value || 0, 10),
                }));

				let data = {
                    site_id: current_site_id,
					name: this.state.name,
					amount_currency: this.state.currency,
					end_ts,
					brokerage_pct,
					amount,
					markets,
					pay_dividends: pay_dividends ? 1 : 0,
					max_amount_per_stock: get_max_amount_per_stock(),
                    risk_values: this.state.use_risk_values ? 1 : 0,
					trade_amount_activated: this.state.trade_amount_activated ? 1 : 0,
                    stock_info_activated: this.state.use_stock_info ? 1 : 0,
					group_games: this.state.use_group_games ? 1 : 0,
                    portfolio_info_activated: this.state.use_portfolio_info ? 1 : 0,
					shorting_enabled: this.state.shorting_enabled ? 1 : 0,
					shorting_amount: this.state.shorting_enabled ? parseFloat(this.state.shorting_amount) : 0,
                    diversification_enabled: this.state.diversification_enabled ? 1 : 0,
                    diversification: this.state.diversification_enabled ? diversificationArr : [],
				};

				if (invite_end_ts) {
					data.invite_end_ts = invite_end_ts;
				}

				if (invite_end_ts === undefined) {
					data.invite_end_ts = end_ts;
				}

				if (this.state.trade_amount_activated) {
					const trade_amount = parseInt(this.state.trade_amount, 10);
					if (isNaN(trade_amount)) {
						this.setState({invalid_input: 'trade_amount'})
					}

					data.trade_amount = trade_amount
				}

				if (this.state.use_volume) {
					data.volume_multiplier = DEFAULT_VOLUME_MULTIPLIER;
				}

				if (start_ts) data.start_ts = start_ts;
				if (window.game_start_ts) data.start_ts = window.game_start_ts; // XXX temporary ability to set start time from JS console

				const post_new_game = () => {
					API.post("/a/new_game", data, (new_game_id) => {
						R.replace("/game/:new_game_id", {new_game_id});
					})
				};

				if (this.props.me) {
					post_new_game();
				} else {
					OpenSignupWithSuccessCallback(post_new_game);
				}
			};
            
			let submitButtonText = <T>Start game</T>
            const goToPremiumForGame = () => {
                setPendingCartGameId(this.props.game_id);
                window.location.assign(getPremiumUpgradeTarget());
            };

            if ((isPremiumFeatureActived && (!this.props.me || !this.props.me.Subscription || this.props.me.Subscription === 'free'))) {
                not_enough_keys_warning_text = 
                <Row className="justify-content-center">
                    <Col className="px-md-2 pt-4">
                        <div className="form-check pt-3 pb-5 text-center">
                            <div className="ad_trade_notice"><T>*To create a game with premium features, you'll need to purchase Premium first.</T></div>
                        </div>
                    </Col>
                </Row>
                submit = (e) => {
                    goToPremiumForGame();
                }
                submitButtonText = <T>Upgrade</T>
            } else {
                not_enough_keys_warning_text = null
            }

			submit_btn = (
				<Row className="justify-content-center">
					<Col className="px-md-4">
						<div className="form-check text-center">
							<Button onClick={submit} className="ad_game_button py-2 px-4">{submitButtonText}</Button>
						</div>
					</Col>
				</Row>
			);
		} else if (this.props.mode === "edit") {
			header = (
				<React.Fragment>
					<Row className="ad_light_gray_bg">
						<Col className="mt-2" align="center">
							<img src="/gfx/pokal_for_edit-0.svg" className="img-fluid" alt="Edit game!"/>
						</Col>
					</Row>
					<Row className="ad_light_gray_bg">
						<Col className="text-center">
							<h1><T>Edit game</T></h1>
						</Col>
					</Row>
					<Row className="pt-3 justify-content-center ad_light_gray_bg ad_thin_bottom">
						<Col md="6" className="text-center ad_p_large ad_gray_fg">
							<T>Here you can edit some of the settings for the game.</T>
						</Col>
					</Row>
				</React.Fragment>
			);
			let submit = (e) => {
				e.preventDefault();
				if (!validate_name()) return;

				const brokerage_pct = validate_and_get_brokerage_pct();
				if (brokerage_pct === undefined) return;

				const max_amount_per_stock = get_max_amount_per_stock();

				const markets = get_selected_markets();

                const diversificationArr = Object.entries(this.state.diversification || {}).map(([stock_type, value]) => ({
                    stock_type,
                    procents: parseInt(value || 0, 10),
                }));

				const data = {
					id: this.props.game_id,
                    site_id: current_site_id,
					params: {
						Name: this.state.name,
						MaxAmountPerStock: max_amount_per_stock,
						BrokeragePct: brokerage_pct,
						Markets: markets,
						VolumeMultiplier: this.state.use_volume ? DEFAULT_VOLUME_MULTIPLIER : 0,
                        RiskValues: this.state.use_risk_values,
                        StockInfo: this.state.use_stock_info,
						GroupGames: this.state.use_group_games,
                        PortfolioInfo: this.state.use_portfolio_info,
                        DiversificationEnabled: this.state.diversification_enabled,
                        Diversification: this.state.diversification_enabled ? diversificationArr : [],
					},
				};
				
				if (this.state.inviteendcustom === "1") {
					const invite_end_str = new Date(this.state.inviteendcustom_chosen_date).toISOString();
					data.params.InviteEndTs = invite_end_str;
				} else {
					data.params.InviteEndTs = this.props.params.Params.EndTime;
				}

				API.post("/a/game_params", data, () => {
					R.go("/game/:game_id", {game_id: this.props.game_id});
				});
			};
            let submitButtonText = <T>Edit game</T>


            const availableKeys = this.props.params.AvailableKeys;
            const invitedUsers = this.props.params.InvitedUsers;
            if (
                isPremiumFeatureActived &&
                this.props.params.Params.GameType === 'free' &&
                (
                    (availableKeys === 0 && invitedUsers !== 0) ||
                    (availableKeys < invitedUsers) ||
                    (availableKeys === 0 && (!this.props.me || !this.props.me.Subscription || this.props.me.Subscription === 'free'))
                )
            ) {
                not_enough_keys_warning_text = 
                <Row className="justify-content-center">
                    <Col className="bg-white px-md-2 pt-4">
                        <div className="form-check pt-3 pb-5 text-center">
                            <div className="ad_trade_notice"><T>*You do not have enough keys to enable premium</T></div>
                        </div>
                    </Col>
                </Row>
                submit = (e) => {
                    setPendingCartGameId(this.props.game_id);
                    window.location.assign(getPremiumUpgradeTarget());
                }
                submitButtonText = <T>Upgrade</T>
            } else if ((isPremiumFeatureActived && this.props.params.Params.GameType === 'free' && invitedUsers !== 0 && availableKeys !== 0)) {
                not_enough_keys_warning_text = 
                <Row className="justify-content-center">
                    <Col className="px-md-2 pt-4">
                        <div className="form-check pt-3 pb-5 text-center">
                            <div className="ad_trade_notice"><T>*Upgrading the game will use {invitedUsers} invites. You currently have {availableKeys} invites available.</T></div>
                        </div>
                    </Col>
                </Row>
                submitButtonText = <T>Upgrade</T>
            } else {
                not_enough_keys_warning_text = null
            }

			submit_btn = (
				<Row className="justify-content-center">
					<Col className="px-md-4">
						<div className="form-check text-center">
							<Butt onClick={submit} className="ad_game_button">{submitButtonText}</Butt>
						</div>
					</Col>
				</Row>
			);
		}

		const { NoEdit } = this;

		const locked_markets = this.props.params && this.props.params.TradedMarkets ? this.props.params.TradedMarkets : [];
		const locked_reason = <T>This market has already been traded in the game and cannot be deselected now</T>;

		const initial_bankroll_defaults = [250000, 1000000].map((value) => ({
			"value": value,
			"text": I18N.floatval_unit(value, 0, default_currency),
		}));

		const isGod = this.props.me && this.props.me.IsGod;

		const sectionsConfig = [
			{id: "game_setup", title: <T>Game Setup</T>, Component: GameSetupSection},
			{id: "team_module", title: <T>Team Module</T>, Component: TeamModuleSection, premium_section: true},
			{id: "capital", title: <T>Capital</T>, Component: CapitalSection},
			{id: "game_mechanics_and_rules", title: <T>Game Mechanics and Rules</T>, Component: GameMechanicsSection},
			{id: "risk_values", title: <T>Risk Values</T>, Component: RiskValuesSection, premium_section: true},
			{id: "data_and_analysis", title: <T>Data and Analysis</T>, Component: DataAndAnalysisSection, premium_section: true},
            {id: "diversification", title: <T>Portfolio Diversification</T>, Component: GameDiversificationSection, premium_section: true},
			{id: "markets_and_equity", title: <T>Markets and Equity</T>, Component: MarketsAndEquitySection},
			{id: "game_action", title: "", Component: GameActionSection, skipNumber: true},
			// Just add more here in the future ;) 
		];

		const sectionsFiltered = sectionsConfig.filter(section => !(section.id === "risk_values" && !isGod));
		const sections = sectionsFiltered.map((section, idx) => ({
			...section,
			title: section.skipNumber ? section.title : <React.Fragment>{idx + 1}: {section.title}</React.Fragment>,
		}));



		return (
			<React.Fragment>
			{header}
			<div className="container-fluid">
				

				<form onSubmit={(e) => { e.preventDefault(); }}>
				{/* Sections */}
				<Container>
					{sections.map(({ id, title, Component, premium_section }) => (
							<div key={id} className="mt-4">
								<Section title={title} premium_section={premium_section}>
								<Component
                                    me={this.props.me}
									state={this.state}
									simple_change={simple_change}
                                    handleDiversificationChange={handleDiversificationChange}
									simple_checkbox_change={simple_checkbox_change}
									name_input_class={name_input_class}
									this_parent={this_parent}
									NoEdit={NoEdit}
									gameStartCalendar={gameStartCalendar}
									RadiosAndCustom={RadiosAndCustom}
									state_invalid_input={state_invalid_input}
									inviteEndCalendar={inviteEndCalendar}
									initial_bankroll_defaults={initial_bankroll_defaults}
									nolimit_txt={nolimit_txt}
									other_txt={other_txt}
									amount_txt={amount_txt}
									render_static={this.props.render_static}
									risk_value_warning_text={risk_value_warning_text}
									mk_market_card_props={mk_market_card_props}
									locked_markets={locked_markets}
									locked_reason={locked_reason}
									crypto_warning_text={crypto_warning_text}
									no_volume_warning_text={no_volume_warning_text}
									not_enough_keys_warning_text={not_enough_keys_warning_text}
									submit_btn={submit_btn}
								/>
								</Section>
							</div>
					))}
				</Container>
				</form>
			</div>
			</React.Fragment>
		);
	}
}

const GameParamsOuter = connect(
	(state) => ({
        me: state.me
    })
)((props) => <TraksConsumer><GameParams {...props}/></TraksConsumer>);

const NewGame = (props) => <GameParamsOuter mode="new" {...props}/>

const EditGame = Apify("/a/game_params")
	.with_response_prop("params")
	.with_query_from_props(props => ({id: props.game_id}))
.wrap((props) => <GameParamsOuter mode="edit" {...props}/>)

export {
	NewGame,
	EditGame,
}



// WEBPACK FOOTER //
// ./src/c/GameParams.js